import axios from 'axios'
axios.defaults.baseURL = 'https://nbd-zt.nbd.com.cn'